import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

import { MUTED_GRAY } from '../constants';

export interface FlickeringStatProps {
  baseValue: number;
  range: number;
  suffix: string;
  color: string;
  label: string;
  flicker?: boolean;
}

export function FlickeringStat({ baseValue, range, suffix, color, label, flicker = true }: FlickeringStatProps) {
  const [val, setVal] = useState(baseValue);

  useEffect(() => {
    const interval = setInterval(
      () => {
        setVal(Math.max(0, baseValue + Math.floor(Math.random() * range) - Math.floor(range / 3)));
      },
      flicker ? 800 : 1500
    );
    return () => clearInterval(interval);
  }, [baseValue, range, flicker]);

  return (
    <div className='text-center'>
      <motion.p className='text-3xl font-bold md:text-4xl' style={{ color, fontFamily: 'var(--font-bai)' }} animate={flicker ? { opacity: [1, 0.7, 1] } : {}} transition={flicker ? { duration: 0.8, repeat: Infinity, ease: 'easeInOut' as const } : undefined}>
        {val}
        {suffix}
      </motion.p>
      <p className='mt-1 text-sm' style={{ color: MUTED_GRAY, fontFamily: 'var(--font-outfit)' }}>
        {label}
      </p>
    </div>
  );
}
